/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of Zuum Transportation Inc.
 #*
 #* Copyright Zuum 2015-2019. All Rights Reserved.
 #*
 #*===================================================================
 */

export interface Document {
    _id: string;
    createdAt: any;
    updatedAt: any;
    approved: boolean;
    approvedByUser: any; // User
    declined: boolean;
    declinedByUser: any; // User
    description: string;
    createdByUser: any;
    createdByUserName: string;
    reason: string;
    // e.g docType: CarrierPacket, W9, Ach --used on UI only
    docType: string;
    isGenerated: boolean;
    isSigned?: boolean;
    isDeleted?: boolean;
    name: string;
    shipment: string;
    type: string;
    url: string;
    url_s: string;
    isPDF: boolean;
    formattedName: string;
    formattedStatus: string;
    location: any;
    shareWithCustomer?: boolean;
    shareWithCarrier?: boolean;
    history: any[];
    isOSD?: boolean;
    // private properties
}

export enum DOCUMENT_TYPES {
    ADVANCE = 'Advance',
    AIRWAY_BILL = 'Airway Bill',
    BANK_DRAFT = 'Bank Draft',
    BROKER_CONTRACT = 'Broker Contract',
    BILL_INVOICE = 'Bill / Invoice',
    BILLING_INSTRUCTIONS = 'Billing Instructions',
    BILL_OF_LADING = 'Bill of Lading(s)',
    CLAIM_DOC = 'Claim Doc',
    CARRIER_INVOICE = 'Carrier Invoice',
    CARRIER_PAYMENT = 'Carrier Payment',
    CARRIER_CONTRACT = 'Carrier Contract',
    CARRIER_CONFIRMATION_SIGNED = 'Carrier Confirmation (Signed)',
    CUSTOMER_CONFIRMATION_SIGNED = 'Customer Confirmation (Signed)',
    CARRIER_PACKET = 'Carrier Agreement (Full)',
    CUSTOMER_PACKET = 'Customer Packet (Full)',
    CUSTOMER_CONTRACT = 'Customer Contract',
    CUSTOMS_DOC = 'Customs Doc',
    CREDIT_APPLICATION = 'Credit Application',
    DETENTION_SHEET = 'Detention sheet',
    DOT_FINE = 'DOT Fine / Notice',
    DELIVERY_ORDER = 'Delivery order',
    DOT = 'DOT / MC / FF / URS Number',
    DUE_DILIGENCE = 'Due Diligence Certificate',
    DRIVER_APPLICATION = 'Driver Application',
    DRIVER_CONTRACT = 'Driver Contract',
    EQUIPMENT = 'Equipment / Lane Request',
    FREIGHT_EXPORT = 'Freight Export Docs',
    FREIGHT_IMPORT = 'Freight Import Docs',
    FEE_APPROVAL_FORM = 'Fee Approval Form',
    FUEL_RECEIPT = 'Fuel receipt',
    INSURANCE_PROOF = 'Insurance (Proof Of)',
    HAZMAT_DOC = 'Hazmat Doc',
    INVOICE = 'Invoice',
    LOAD_TENDER = 'Load Tender',
    LUMPER_RECEIPT = 'Lumper receipt',
    MAINTENANCE = 'Maintenance / Repair',
    MARKETING_PACKET = 'Marketing Packet',
    MEAL_RECEIPT = 'Meal receipt',
    OTHER = 'Other / Miscellaneous',
    PACKING_LIST = 'Packing List / Slip',
    PHOTOGRAPH_DELIVERED_LOAD = 'Photograph of Delivered Load',
    PHOTOGRAPH_PICKUP_LOAD = 'Photograph of Pick Up Load',
    PICTURE_OF_ACCIDENT = 'Picture of accident',
    PICTURE_OF_REPAIR = 'Picture of repair',
    PICTURE_OF_WEATHER = 'Picture of weather',
    QUICK_PAY = 'Quick Pay / Settlement Form',
    RECEIVER_RECEIPT = 'Receiver receipt (delivery receipt)',
    REPAIR_INVOICE = 'Repair invoice',
    SALES_PACKET = 'Sales Packet',
    SCALE_TICKET = 'Scale ticket',
    SIGNED_PROOF_OF_DELIVERY = 'Signed Proof Of Delivery',
    SIGNED_PROOF_OF_DELIVERY_2 = 'POD - Signed Proof Of Delivery',
    TOLL_RECEIPT = 'Toll receipt',
}

export enum GENERATED_DOC_TYPE {
    BILL_LADDING = 'Bill of Lading',
    BBOL = 'Blind Bill of Lading',
    TPBOL = 'Third Party Bill of Lading',
    CUSTOMER_CONFIRMATION = 'Customer Confirmation',
    CARRIER_CONFIRMATION = 'Carrier Confirmation',
    BLIND_CARRIER_CONFIRMATION = 'Blind Carrier Confirmation',
    SCC = 'Signed Carrier Confirmation',
}

export const CarrierSensitiveDocs: string[] = [
    DOCUMENT_TYPES.CARRIER_INVOICE,
    DOCUMENT_TYPES.CARRIER_PAYMENT,
    DOCUMENT_TYPES.CARRIER_CONTRACT,
    DOCUMENT_TYPES.CARRIER_CONFIRMATION_SIGNED,
    DOCUMENT_TYPES.CARRIER_PACKET,
];
export const CustomerSensitiveDocs: string[] = [
    DOCUMENT_TYPES.CUSTOMER_CONFIRMATION_SIGNED,
    DOCUMENT_TYPES.CUSTOMER_PACKET,
    DOCUMENT_TYPES.CUSTOMER_CONTRACT,
];
